import Chart from "react-apexcharts";
import { reduzirNome } from "../../../utils/reduzirNome";

export default function BarFornecedores({ data }) {
    const fornecedores = Object.keys(data?.totalPorFornecedor || {});
    const valoresFornecedores = Object.values(data?.totalPorFornecedor || {});

    const nomesFornecedores = fornecedores.map(codigo => {
        const fornecedor = data?.solicitacoes.find(d => d.codigoFornecedor === codigo);
        return fornecedor ? fornecedor.nomeFornecedor + ' - ' + codigo : codigo;
    });

    const options = {
        chart: {
            type: "bar",
            toolbar: { show: false },
            scrollablePlotArea: {
                enabled: true,
                originX: 0,
                scrollY: false,
            },
        },
        xaxis: {
            categories: nomesFornecedores.map((item) => reduzirNome(item)),
            labels: {
                style: { fontSize: "12px" },
            },
        },
        dataLabels: {
            enabled: false,
        },
        yaxis: {
            floating: false,
            logarithmic: true, // escala logarítmica
            labels: {
                show: true,
                minWidth: 75,   // largura mínima reservada p/ os valores
                maxWidth: 75,   // largura máxima (fixa),
                formatter: (value) =>
                    Number(value).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                    }),
            },
        },
        tooltip: {
            y: {
                formatter: (value) =>
                    Number(value).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                    }),
            },
            x: {
                formatter: (_, opts) => {
                    const index = opts.dataPointIndex;
                    return nomesFornecedores[index]; // mostra nome completo
                },
            },
        },
        plotOptions: {
            bar: {
                borderRadius: 6,
                columnWidth: "60%",
            },
        },
        colors: ["#3b3ef6ff", "#4d37ceff"],
        legend: {
            position: "top",
            labels: { colors: "#333" },
            fontSize: "12px",
        },
        responsive: [
            {
                breakpoint: 768,
                options: {
                    plotOptions: { bar: { columnWidth: "80%" } },
                    xaxis: { labels: { rotate: -45 } },
                },
            },
        ],
    };

    const series = [
        {
            name: "Valor (R$)",
            data: valoresFornecedores,
        },
    ];

    return (
        <div className="bg-card border border-border p-4 rounded-2xl shadow-soft overflow-x-auto">
            <h2 className="text-xl font-display font-bold mb-4 text-foreground">Total por Fornecedor</h2>
            <div className="min-w-[800px] overflow-x-auto">
                <div className="w-full ">
                    <Chart width={7000} options={options} series={series} type="bar" height="350" />
                </div>
            </div>
        </div>
    );
}
